module.exports = __webpack_public_path__ + "media/images/icon-dollar-051b5ec739a8cdeeecdd7ebf52cec4ad.svg";